import { IS_AI_AND_BRAND_KIT_ENABLED } from 'admin/constants/release-features';
import { createSelector } from 'reselect';
import { getFormValues } from 'redux-form';
import type { AdminReducerState } from 'admin/reducers';
import type { SupportedLanguage } from 'common/i18n';
import { StoryFacade } from 'utils/facades/story-facade';
import { FORM_MODEL } from 'admin/constants/common';

export const selectStoryEditor = (state: AdminReducerState) => state.storyEditor;

export const selectEditableStoryForm = (state: AdminReducerState) =>
	getFormValues(FORM_MODEL.EDIT_STORY)(state) as AdminReducerState['storyEditor']['story'];

export const selectEditableStory = createSelector(selectStoryEditor, state => state.story);

export const selectEditableStoryId = createSelector(selectEditableStory, story => story?.id);

export const selectEditableStoryType = createSelector(selectEditableStory, story => story?.type);

// todo: refactor to get rid of "!"
export const selectStoryFacade = createSelector(selectEditableStory, story => new StoryFacade(story!));

export const selectStoryCards = createSelector(selectStoryFacade, facade => facade.cards);

export const selectStoryMediaQuery = createSelector(selectStoryFacade, facade => facade.mediaQuery);

export const selectStoryLang = createSelector(selectStoryFacade, facade => facade.language as SupportedLanguage);

export const selectStorycardsDomain = createSelector(selectEditableStory, story => story?.storycardsDomain);

export const selectStoryGenerator = createSelector(selectStoryFacade, story => story.settings.generator);

export const selectStoryDesign = createSelector(selectStoryFacade, story => story.settings.design);

export const selectOpCounter = createSelector(selectStoryEditor, story => story.story?.opCounter ?? 1);

const selectMemberChatOpen = (state: AdminReducerState) => state.user.preferences.chat.open;

export const selectStoryEditorChatOpen = createSelector(
	[selectStoryEditor, selectMemberChatOpen],
	(story, memberChatOpen) => IS_AI_AND_BRAND_KIT_ENABLED && (story.chat.open ?? memberChatOpen)
);

export const selectStoryEditorChatMention = createSelector(selectStoryEditor, story => story.chat.mention);

export const selectStoryEditorChatDraft = createSelector(selectStoryEditor, story => story.chat.draft);

export const selectStoryEditorFocusMode = createSelector(selectStoryEditor, story => story.ui.focusMode);

export const selectStoryEditorInspectorOpen = createSelector(selectStoryEditor, story => story.ui.inspectorOpen);
